import { render, staticRenderFns } from "./Agile.vue?vue&type=template&id=06f725e8&"
import script from "./Agile.vue?vue&type=script&lang=js&"
export * from "./Agile.vue?vue&type=script&lang=js&"
import style0 from "./Agile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports